import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCalendarController } from './calendarContext';
import { CalendarDays } from 'lucide-react';
import CalendarLegend from './CalendarLegend';
import DateCalendarWrapper from './DateCalendarWrapper';

const CalendarModal: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { selectedDate } = useCalendarController();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button
        onClick={handleOpen}
        className={`p2-regular flex items-center justify-center gap-[8px] font-normal border text-left p-[12px] transition duration-200 rounded-md ${
          !selectedDate
            ? 'bg-blue-20 border-blue-1000 text-blue-1000'
            : 'bg-neutral-10 border-neutral-40'
        }`}
      >
        <CalendarDays size={20} />
        <span> {t('ticketSale.openCalendarButtonText')} </span>
      </button>

      <Dialog
        onClose={handleClose}
        open={open}
        sx={{ '& .MuiDialog-container': { alignItems: 'flex-start' } }}
      >
        <DateCalendarWrapper handleClose={handleClose} />
        <div className="px-[24px] pb-[24px] pt-[12px] grid grid-cols-2 gap-[8px] border-t border-neutral-40">
          <CalendarLegend />
        </div>
      </Dialog>
    </>
  );
};

export default CalendarModal;
